const GET_PERSON_ACTIONS = 'dofe-fo/action/GET_PERSON_ACTIONS'
const GET_PERSON_ACTIONS_SUCCESS = 'dofe-fo/action/GET_PERSON_ACTIONS_SUCCESS'
const GET_PERSON_ACTIONS_FAIL = 'dofe-fo/action/GET_PERSON_ACTIONS_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  list: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PERSON_ACTIONS:
      return {
        ...state,
        loading: true
      }
    case GET_PERSON_ACTIONS_SUCCESS:
      return {
        ...state,
        list: action.result,
        loading: false,
        loaded: true
      }
    case GET_PERSON_ACTIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getPersonActions(id) {
  return {
    types: [GET_PERSON_ACTIONS, GET_PERSON_ACTIONS_SUCCESS, GET_PERSON_ACTIONS_FAIL],
    promise: client => client.get(`api/persons/${id}/actions`)
  }
}

